export default "__VITE_ASSET__CtWU7dW___"